/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CentreNotificationsGridDto
 */
export interface CentreNotificationsGridDto {
    /**
     * 
     * @type {number}
     * @memberof CentreNotificationsGridDto
     */
    idsuivi?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CentreNotificationsGridDto
     */
    realisateurSuivi?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CentreNotificationsGridDto
     */
    idencodeur?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CentreNotificationsGridDto
     */
    encodeur?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CentreNotificationsGridDto
     */
    idrealisateurSuivi?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof CentreNotificationsGridDto
     */
    dateSuivi?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof CentreNotificationsGridDto
     */
    idapprenant?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CentreNotificationsGridDto
     */
    idformateur?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CentreNotificationsGridDto
     */
    idrepresentant?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CentreNotificationsGridDto
     */
    idchefEntreprise?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CentreNotificationsGridDto
     */
    idtuteur?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CentreNotificationsGridDto
     */
    idcontact?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CentreNotificationsGridDto
     */
    beneficiaire?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CentreNotificationsGridDto
     */
    idtypeSuivi?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CentreNotificationsGridDto
     */
    typeSuivi?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CentreNotificationsGridDto
     */
    sousTypeSuivi?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CentreNotificationsGridDto
     */
    origineSuivi?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CentreNotificationsGridDto
     */
    idsousTypeSuivi?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CentreNotificationsGridDto
     */
    service?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CentreNotificationsGridDto
     */
    masquee?: boolean;
}

/**
 * Check if a given object implements the CentreNotificationsGridDto interface.
 */
export function instanceOfCentreNotificationsGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CentreNotificationsGridDtoFromJSON(json: any): CentreNotificationsGridDto {
    return CentreNotificationsGridDtoFromJSONTyped(json, false);
}

export function CentreNotificationsGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CentreNotificationsGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idsuivi': !exists(json, 'idsuivi') ? undefined : json['idsuivi'],
        'realisateurSuivi': !exists(json, 'realisateurSuivi') ? undefined : json['realisateurSuivi'],
        'idencodeur': !exists(json, 'idencodeur') ? undefined : json['idencodeur'],
        'encodeur': !exists(json, 'encodeur') ? undefined : json['encodeur'],
        'idrealisateurSuivi': !exists(json, 'idrealisateurSuivi') ? undefined : json['idrealisateurSuivi'],
        'dateSuivi': !exists(json, 'dateSuivi') ? undefined : (json['dateSuivi'] === null ? null : new Date(json['dateSuivi'])),
        'idapprenant': !exists(json, 'idapprenant') ? undefined : json['idapprenant'],
        'idformateur': !exists(json, 'idformateur') ? undefined : json['idformateur'],
        'idrepresentant': !exists(json, 'idrepresentant') ? undefined : json['idrepresentant'],
        'idchefEntreprise': !exists(json, 'idchefEntreprise') ? undefined : json['idchefEntreprise'],
        'idtuteur': !exists(json, 'idtuteur') ? undefined : json['idtuteur'],
        'idcontact': !exists(json, 'idcontact') ? undefined : json['idcontact'],
        'beneficiaire': !exists(json, 'beneficiaire') ? undefined : json['beneficiaire'],
        'idtypeSuivi': !exists(json, 'idtypeSuivi') ? undefined : json['idtypeSuivi'],
        'typeSuivi': !exists(json, 'typeSuivi') ? undefined : json['typeSuivi'],
        'sousTypeSuivi': !exists(json, 'sousTypeSuivi') ? undefined : json['sousTypeSuivi'],
        'origineSuivi': !exists(json, 'origineSuivi') ? undefined : json['origineSuivi'],
        'idsousTypeSuivi': !exists(json, 'idsousTypeSuivi') ? undefined : json['idsousTypeSuivi'],
        'service': !exists(json, 'service') ? undefined : json['service'],
        'masquee': !exists(json, 'masquee') ? undefined : json['masquee'],
    };
}

export function CentreNotificationsGridDtoToJSON(value?: CentreNotificationsGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idsuivi': value.idsuivi,
        'realisateurSuivi': value.realisateurSuivi,
        'idencodeur': value.idencodeur,
        'encodeur': value.encodeur,
        'idrealisateurSuivi': value.idrealisateurSuivi,
        'dateSuivi': value.dateSuivi === undefined ? undefined : (value.dateSuivi === null ? null : value.dateSuivi.toISOString()),
        'idapprenant': value.idapprenant,
        'idformateur': value.idformateur,
        'idrepresentant': value.idrepresentant,
        'idchefEntreprise': value.idchefEntreprise,
        'idtuteur': value.idtuteur,
        'idcontact': value.idcontact,
        'beneficiaire': value.beneficiaire,
        'idtypeSuivi': value.idtypeSuivi,
        'typeSuivi': value.typeSuivi,
        'sousTypeSuivi': value.sousTypeSuivi,
        'origineSuivi': value.origineSuivi,
        'idsousTypeSuivi': value.idsousTypeSuivi,
        'service': value.service,
        'masquee': value.masquee,
    };
}

